const SITE_ENV = process.env.SITE_ENV;

type ExcludedLocalSiteEnv = Exclude<typeof SITE_ENV, "local">;

export const siteEnvIs = (envsArray: ExcludedLocalSiteEnv[]) => {
  return envsArray.includes(SITE_ENV as ExcludedLocalSiteEnv);
};

type ProjectsTag = "GM" | "GB";

const siteEnvMatchConfig = {
  GM: ["gmtest", "gmprod"],
  GB: ["tgb", "pre", "prod"],
} satisfies Record<ProjectsTag, ExcludedLocalSiteEnv[]>;

export const projectIs = (projectsArray: ProjectsTag[]) => {
  const isLocalProjectTagMatching =
    process.env.SITE_ENV === "local" &&
    projectsArray.some((project) => project === process.env.LOCAL_PROJECT_TAG);

  const isSiteEnvMatchingTargetProject = projectsArray.some((project) => {
    return siteEnvIs(siteEnvMatchConfig[project]);
  });

  return isLocalProjectTagMatching || isSiteEnvMatchingTargetProject;
};
